import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/templates/setup-sheet-styles/:id");
export const getIndexPath = returnPath("/templates/setup-sheet-styles");
